export default __webpack_public_path__ + "static/media/book-toc.aca110d6.jpg";